import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import { Alert, Grid, Stack, Typography } from "@mui/material";
import moment from "moment";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

const PollTimer = ({ poll, onClosed }) => {
    const [pollTimerKey, setPollTimerKey] = useState(Date.now().toString());
    const [isClosed, setClosed] = useState(false);

    useEffect(() => {
        if (poll && poll.status === 1 && !!poll.expireDate) {
            const handler = setInterval(() => setPollTimerKey(Date.now().toString()), 1000);
            return () => clearInterval(handler);
        }
    }, [poll]);

    useEffect(() => {
        if (isClosed && onClosed) {
            onClosed();
        }
    }, [isClosed, onClosed])

    if (poll.status !== 1 || !poll.expireDate) {
        return null;
    }

    const timeDiff = moment(poll.expireDate).diff(moment());
    const duration = moment.duration(timeDiff, 'milliseconds');
    const seconds = duration.seconds();
    const minutes = duration.minutes();
    const hours = duration.hours();
    const days = duration.days();
    const months = duration.months();
    const years = duration.years();

    const countDownText = () => {
        return `${years > 0 ? `${years} ${years > 1 ? 'years' : 'year'}` : ''}${months > 0 ? ` ${months} ${months > 1 ? 'months' : 'month'}` : ''}${days > 0 ? ` ${days} ${days > 1 ? 'days' : 'day'}` : ''}${hours > 0 ? ` ${hours} ${hours > 1 ? 'hours' : 'hours'}` : ''}${minutes > 0 ? ` ${minutes} ${minutes > 1 ? 'minutes' : 'minute'}` : ''}${seconds > 0 ? ` ${seconds} ${seconds > 1 ? 'seconds' : 'second'}` : ''}`.trim();
    }

    if (!isClosed && timeDiff < 0) {
        setClosed(true);
    }

    return <Grid item xs={12} justifyContent={'center'} display={'flex'}>
        <Alert variant='outlined' severity={'info'}>
            <Stack direction={'row'} spacing={1}>
                {timeDiff < 1000 && <Typography key={pollTimerKey} sx={{ color: 'white' }}>{`This poll is closed`}</Typography>}
                {timeDiff >= 1000 && <Typography key={pollTimerKey} sx={{ color: 'white' }}>{`This poll closes in ${countDownText()}`}</Typography>}
                <HourglassTopIcon sx={{ color: 'white' }} />
            </Stack>
        </Alert>
    </Grid>
}

PollTimer.propTypes = {
    poll: PropTypes.any.isRequired,
    onClosed: PropTypes.func
}

export default PollTimer;